import { ApiError, QueryKeys, QuickReply } from '@connect-x-app/shared-domain-models';
import { getQuickReplies } from '@connect-x-app/web-data-access';
import { useQuery } from '@tanstack/react-query';

export const useQuickReplies = () =>
  useQuery<Required<QuickReply>[], ApiError>({ queryFn: getQuickReplies, queryKey: [QueryKeys.QUICK_REPLIES] });
